import { createPinia } from 'pinia';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import type { ViteSSGContext } from 'vite-ssg';

import { provideTelemetry } from '../telemetry';
import { installRouterGuards } from './router';
import { installTelemetry } from './telemetry';
import vuetify from './vuetify';

export function registerPlugins({ app, router, initialState }: ViteSSGContext) {
    // First, so the provider's error handler and router instrumentation are in
    // place before any other plugin has a chance to throw.
    provideTelemetry(app, installTelemetry(app, router));

    const pinia = createPinia();
    app.use(pinia);
    if (import.meta.env.SSR) {
        initialState.pinia = pinia.state.value;
    } else {
        pinia.state.value = initialState.pinia || {};
    }

    app.use(vuetify);
    installRouterGuards(router);
}
